import { IGroupState, initialGroupState } from './group/groupState';
import { initialPersonState, IPersonState } from './person/personState';

export interface IApplicationState {
    groupData: IGroupState;
    oidc?: any;
    person: IPersonState;
}

export const initialApplicationState: IApplicationState = {
    groupData: initialGroupState,
    person: initialPersonState,
}